import BaseService from '../services/baseService';
import ToastrService from '../services/toastrService';
import * as types from '../actions/actionTypes';
import * as accountUtils from '../utils/accountUtils';
import * as accountActions from '../actions/accountActions';
import { push } from 'react-router-redux';

export default function serviceMiddleware() {
    return ({ dispatch, getState }) => next => action => {
        if (action.type == types.LOGIN_SUCCESS) {
            //const state = getState();
            debugger;
            BaseService.setToken(action.payload.access_token, action.payload['.expires']);
        }
        else if(action.type == types.LOGOUT) {
            BaseService.clearToken();
            const state = getState();
            //we want to clear the local storage straight away instead of waiting for the 1 second defined in the boot client
            debugger;
            accountUtils.saveAccountDetails(state.account);

            const { next, showSuccessToast } = action.payload;
            dispatch(push(next || '/'));
            accountActions.clearNotificationCountHandle();
            if(showSuccessToast) {
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'You have logged out successfully!');
            }
        }      
        return next(action);
    };
  }
